
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  otpinfo:null,
  resendotpinfo:null,
  otpverified:localStorage.getItem("otpverified") || false,
  otperror:null,
  otpfetching:false,
  userEmail:localStorage.getItem("userEmail") || null,
  isUser:false
};

const otpSlice = createSlice({
  name: "Cart",
  initialState,
  reducers: { 
    otpRequest: (state, action) => {
        state.otpfetching=true;
        state.otperror=null;
    },
    otpSuccess: (state, action) => {
        state.otpfetching=false;
        state.otpinfo=action.payload
        state.userEmail=action.payload.email
        state.isUser=action.payload.isUser
        localStorage.setItem("userEmail", action.payload.email)
    },
    resendOtpSuccess: (state, action) => {
      state.otpfetching=false;
      state.resendotpinfo=action.payload
      state.userEmail=action.payload.email
      state.isUser=action.payload.isUser
      localStorage.setItem("userEmail", action.payload.email)
  },
    otpVerified:(state, action) => {
        state.otpfetching=false;
        state.otpverified=true;
        state.otpinfo=action.payload
        state.userEmail=action.payload.email
        state.isUser=action.payload.isUser
        localStorage.setItem("userEmail", action.payload.email)
        localStorage.setItem("otpverified",true)
    },
   otpFail: (state,action) => {
    
    state.otpfetching=false;
    state.otperror= action.payload;
    },
    clearOtpError:(state,action)=>{
        state.otpfetching=false;
        state.otperror=null;
        state.otpinfo=null;
       
    },
    clearUserEmail:(state)=>{
      state.userEmail=null;
      localStorage.removeItem("userEmail");
    },
    clearOtpVerified:(state)=>{
      state.otpverified=false;
      state.isUser=undefined;
      localStorage.removeItem("otpVerified");
    }
  },
});
export const { otpRequest,resendOtpSuccess, clearOtpVerified, otpSuccess, otpFail,otpVerified ,clearOtpError,clearUserEmail} =
  otpSlice.actions;
  
export default otpSlice.reducer;
